export default "__VITE_ASSET__CeZdVnOH__"